import { render } from "./ResourcegroupsIndex.vue?vue&type=template&id=3154f91a&scoped=true"
import script from "./ResourcegroupsIndex.vue?vue&type=script&lang=js"
export * from "./ResourcegroupsIndex.vue?vue&type=script&lang=js"

import "./ResourcegroupsIndex.vue?vue&type=style&index=0&id=3154f91a&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3154f91a"]])

export default __exports__